import {defineMessages, FormattedMessage} from 'react-intl';

import {Button, Spinner} from '@sail/ui';

import {RequestACallCodesEndpointResponseSuccess} from '../../../../generated/types';

const messages = defineMessages({
  cancel: {
    id: 'conversations_assistant.requestACallTopBar.cancel',
    description: 'Button to cancel the request a call',
    defaultMessage: 'Cancel',
  },
  calling: {
    id: 'conversations_assistant.requestACallTopBar.calling',
    description: 'Button text when a call is in progress',
    defaultMessage: 'Calling',
  },
});

type RacStatus = RequestACallCodesEndpointResponseSuccess['racStatus'];

export const CancelButton = ({
  isLoading,
  racStatus,
  onCancel,
}: {
  isLoading: boolean;
  racStatus: RacStatus;
  onCancel: () => void;
}) => {
  const isCalling = racStatus === 'calling';
  const isDisabled = racStatus === 'pending' || racStatus === 'calling';

  return (
    <Button
      data-testid="cancel-rac-button"
      size="small"
      css={{marginLeft: 'small'}}
      onPress={onCancel}
      disabled={isDisabled || isLoading}
    >
      {isLoading ? (
        <Spinner
          data-testid="loading-spinner"
          css={{
            width: 'fill',
            paddingX: 'small',
          }}
        />
      ) : (
        <FormattedMessage
          {...(isCalling ? messages.calling : messages.cancel)}
        />
      )}
    </Button>
  );
};
